import { create } from 'zustand';

export const useGroupedUserListStore = create((set) => ({
    users: [],
    loading: false,
    setUsers: (users) => set({ users }),
    setLoading: (loading) => set({ loading }),
}));
